import { Reducer, ReducersMapObject } from 'redux';

export type ChangeListener = (reducers: ReducersMapObject) => void;

export class ReducerRegistry {
    private reducers: ReducersMapObject = {};
    private emitChange: ChangeListener | null = null;

    public getReducers() {
        return { ...this.reducers };
    }

    public register(name: string, reducer: Reducer) {
        this.reducers = {
            ...this.reducers,
            [name]: reducer,
        };
        if (this.emitChange) {
            this.emitChange(this.getReducers());
        }
    }

    public setChangeListener(listener: ChangeListener) {
        this.emitChange = listener;
    }
}

export default new ReducerRegistry();
